import template from "./pCasemanClientNewConfig.html";

export function pCasemanClientNewConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanClientNewConfigController,
    controllerAs: 'pCasemanClientNewConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanClientNewConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.matchBlocked = false;
    this.showOnlyActive = true;
    this.activeClientsKlix = [];

    this.headers = [
      {name: "CASEMAN.CLIENT_KLIX", class: "table-info"},
      {name: "CASEMAN.CLIENT_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 200);
        this.$scope.$on("$destroy", () => {
          this.$interval.cancel(timeout);
        });
        this.getData();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getData() {
    this.Caseman.getCountryCasemanClients().then(
      (success) => {
        this.state = "loaded";
        if (success.data.length == 0 || !success.data) {
          this.noClients = true;
          this.clientsCASEMAN = [];
        } else {
          this.clientsKlix = success.data.clients.sort(this.Sort.abcBy("name"));
          this.activeClientsKlix = this.clientsKlix.filter(client => client.isActive);

          this.clientsCASEMAN = success.data.casemanClients
            .filter((client) => client.isActive === true)
            .filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
            .sort(this.Sort.abcBy("name"));
          this.toggleActive();
        }
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  getMapperToDisplay(klixClients) {
    const mapperToDisplay = klixClients && klixClients.map(clientKlix => {

      let client = {
        clientId: clientKlix.id,
        clientName: clientKlix.name,
        isActive: clientKlix.isActive,
        casemanClientName: clientKlix.casemanClientName,
        unmatched: true
      };
      if (clientKlix.casemanClientName !== undefined) {
        client = {
          ...client,
          unmatched: false
        };
      }

      if (clientKlix.additionalInfo)
        client.nameWithAdditionalInfo = `(${clientKlix.additionalInfo}) ${clientKlix.name}`;

      return client;
    });
    return mapperToDisplay;
  }

  refresh() {
    this.getData();
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
  }

  back() {
    window.history.back();
  }

  editClient(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = {id: entity.casemanClientId, name: entity.casemanClientName};
    this.hintClient = entity.clientName.substr(0, entity.clientName.indexOf(' ') + 1);
  }

  saveClientMatch(client, projectToMatch) {
    this.state = "loading";
    this.Caseman.setClientClientMapper(client.clientId, angular.fromJson(projectToMatch).id).then(
      () => {
        this.clientToMatch = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteClient(entity) {
    let casemanClient = this.clientsCASEMAN.filter((clientCaseman) => {
      if (clientCaseman.name === entity.casemanClientName)
        return clientCaseman;
    });

    this.state = "loading";
    this.Caseman.deleteClientClientMapper(entity.clientId, casemanClient[0].id).then(
      () => {
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = null;
  }

  toggleActive() {
    if (this.showOnlyActive) {
      this.mapperToDisplay = this.getMapperToDisplay(this.activeClientsKlix);
    } else {
      this.mapperToDisplay = this.getMapperToDisplay(this.clientsKlix);
    }
  }
}
